import { __makeTemplateObject } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { Global, css } from '@emotion/react';

var WebFonts = function (_a) {
    var theme = _a.theme;
    var googleWebFontFamilies = theme.googleWebFontFamilies;
    if (!googleWebFontFamilies)
        return null;
    var imports = googleWebFontFamilies
        .map(function (family) {
        return "@import url(\"https://fonts.googleapis.com/css?family=".concat(family, "\");");
    })
        .join("\n");
    return (jsx(Global, { styles: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), imports) }));
};
var templateObject_1;

export { WebFonts };
//# sourceMappingURL=WebFonts.js.map
